import {
    DisciplineEnum,
    OrganisationUnitRoleApiEnum,
    PersonReferenceApiInterface,
    UserOrganisationUnitApiInterface,
} from 'submodules/api_middleware';

export enum MembershipPaymentStatus {
    Unpaid = 0,
    Pending = 1,
    Paid = 2,
}

export interface MembershipValidityIntervalInterface {
    from: string;
    to: string;
}

export interface MembershipPaymentInterface {
    amount: number;
    bank_account: string;
    iban: string;
    variable_symbol: string;
    due_date: string;
    discipline: DisciplineEnum;
    validity: MembershipValidityIntervalInterface;
    status: MembershipPaymentStatus;
}

export interface MembershipApplicationPaymentInterface
    extends MembershipPaymentInterface {
    application_id: string;
    administration_fee: number;
}

export interface UserOrganisationUnit
    extends Omit<UserOrganisationUnitApiInterface, 'role'> {
    roles: OrganisationUnitRoleApiEnum[] | 'all';
}

export interface UserOrganisationUnitRole {
    email: string;
    is_admin: boolean;
    person: PersonReferenceApiInterface;
    phone: string;
    role: OrganisationUnitRoleApiEnum;
}
